import { Map, List } from 'immutable';
import createSelector from '../../utils/reselect';

export const getCalendar = (state: any) => {
    const { calendar } = state;
    return calendar || Map();
};
/*
 * getCalendarEvents will return event list
 */
export const getCalendarEvents = createSelector(getCalendar, (state) => {
    return state.getIn(['eventList', 'data']);
});

/*
 * getApplicationListLoading will return application list loading state
 */
export const getEventListLoading = createSelector(getCalendar, (state) => {
    return state.getIn(['eventList', 'loading']) || false;
});

/*
 * load more boolean to see if there are more record on server
 */
export const getLoadMore = createSelector(getCalendar, (state) => {
    return state.getIn(['eventList', 'loadMore']);
});

/*
 * getEventCount will return total event count
 */
export const getEventCount = createSelector(getCalendar, (state) => {
    return state.getIn(['eventList', 'eventCount']) || Map();
});

/*
 * getFilteredEventListLoading will return application list loading state while filtering
 */
export const getFilteredEventListLoading = createSelector(getCalendar, (state) => {
    return state.getIn(['eventList', 'filterLoading']) || false;
});

/*
 * getUpdateLicenseLoader will return update license api loader status
 */
export const getCalendarFilterSelections = createSelector(getCalendar, (state) => {
    return state.getIn(['eventFilters', 'filterSelections']) || {};
});

/*
 * getInspectorPackLoading will return Loader State for the document download
 */
export const getInspectorPackLoading = createSelector(getCalendar, (state) => {
    return state.getIn(['templates', 'loading']);
});

export const getLinkedLicensesForAppointment = createSelector(getCalendar, (state) => {
    return state.getIn(['linkedLicenses', 'data']) || List();
});

export const getFilteredLicensesForAppointments = createSelector(getCalendar, (state) => {
    return state.getIn(['personLicenses', 'data']) || List();
});

export const getFilteredLicensesLoadingStatus = createSelector(getCalendar, (state) => {
    return state.getIn(['personLicenses', 'loading']);
});

export const getSpecificLicenses = createSelector(getCalendar, (state) => {
    return state.getIn(['appointmentLicenses', 'data']) || List();
});

export const getAppointmentLicensesLoading = createSelector(getCalendar, (state) => {
    return state.getIn(['appointmentLicenses', 'loading']);
});

export const getCalendarSearchForm = createSelector(getCalendar, (state) => {
    return state.getIn(['calendarSearchForm', 'data']);
});

export const getCalendarSearchFormLoadingStatus = createSelector(getCalendar, (state) => {
    return state.getIn(['calendarSearchForm', 'loading']);
});
